var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kontainer",staticStyle:{"height":"600px"}},[_c('div',{staticClass:"toolbox"},[_c('button',{on:{"click":_vm.updateFirstRow}},[_vm._v("Update first row")]),_c('button',{on:{"click":_vm.changeZoomLevel}},[_vm._v("Change zoom level")])]),_c('div',{ref:"gstc",staticClass:"gstc-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }